import React, { useState } from "react";
import NFCScanner from "../components/Nfc/NFCScanner";
import { useUser } from "../context/UserContext";
import { fetchWithAuth } from '../utils/fetchWithAuth';

const NfcUserScanner = () => {
    const { hasPermission } = useUser();
	const canScan = hasPermission("nfc", "scan");

    const [result, setResult] = useState(null);
    const [error, setError] = useState("");

    const handleTagScan = async (tagId) => {

        try {
            const res = await fetchWithAuth(
                `${process.env.REACT_APP_API_URL}/nfc-checkpoints/verify`,
                {
                    method: "POST",   
                    body: JSON.stringify({
                        tagId,
                    }),
                }
            );

            const data = await res.json();

            if (res.ok && data.match) {
                setResult(data);
                setError("");
            } else {
                setResult(null);
                setError(data.error || "Ошибка верификации");
            }
        } catch (err) {
            console.error("Ошибка при сканировании:", err);
            setError("Ошибка подключения к серверу");
        }
    };

    if (!canScan) {
        return (
            <div className="p-6 max-w-lg mx-auto bg-[#252526] text-[#CCCCCC] border border-[#3E3E42] rounded-lg shadow">
                <h2 className="text-2xl font-semibold mb-4">Идентификация по NFC</h2>
                <p className="text-red-400">У вас нет прав на использование сканера</p>
            </div>
        );
    }

    return (
        <div className="p-6 max-w-lg mx-auto bg-[#252526] text-[#CCCCCC] border border-[#3E3E42] rounded-lg shadow">
            <h2 className="text-2xl font-semibold mb-4">Идентификация по NFC</h2>

            <NFCScanner onScan={handleTagScan} />

            {error && (
                <div className="mt-4 p-3 bg-[#1E1E1E] border border-[#3E3E42] rounded">
                    <p className="text-red-400 text-sm">❌ {error}</p>
                </div>
            )}

            {result?.user && (
                <div className="mt-6 p-4 rounded border border-[#3E3E42] bg-[#1E1E1E] text-[#CCCCCC]">
                    <p className="mb-2">✅ Успешно идентифицирован:</p>
                    <p className="text-lg font-semibold">
                        {result.user.username} {result.user.firstName}{" "}
                        {result.user.lastName}
                    </p>
                </div>
            )}
        </div>
    );
};

export default NfcUserScanner;
